import React, { useEffect, useState } from 'react';
import Loader from '../../components/Loader/Loader';
import MoreInfo from './MoreInfo/MoreInfo';
import './Angebote.css';
import AngeboteBody from './AngeboteBody/AngeboteBody';
import Footer from '../components/FooterDE/FooterDE';
import Header from '../components/HeaderDE/HeaderDE';
import euLadyBackgr1 from '../../assets/eu-lady-background.png';
import euLadyBackgr2 from '../../assets/eu-lady-background2.png';
import edekaGiftCard from '../../assets/DE/edka-gift-card2.png';
import amazonGiftCard from '../../assets/DE/amazon-gift-card.png';
import GDPRCookieConsent from '../../components/CookieConsent/GDPRCookieConsent';
import { useTranslation } from '../../locales/useTranslation';

const Angebote = ({ pageName }) => {
  const { t, translations } = useTranslation('de');
  const [title, setTitle] = useState('Geschenkkarte Gewinnspiel! Registrieren Sie sich, um fortzufahren!');
  const [headline, setHeadline] = useState('');
  const [picURL, setpicURL] = useState('');
  const [loading, setLoading] = useState(false);
  const [backGr1, setBackgr1] = useState('none');
  const [backGr2, setBackgr2] = useState('none');
  const [textColorDesktop, setTextColorDesktop] = useState('rgb(44, 78, 146)');
  const [textColorMobile, setTextColorMobile] = useState('white');
  const [campaignName, setCampaignName] = useState('DE EDEKA 500€');

  useEffect(() => {
    // EDEKA 500€ offer
    if (pageName.includes('edeka') && pageName.includes('500')) {
      setTitle('EDEKA Geschenkkarte Gewinnspiel!');
      setHeadline('Ihr EDEKA Gutschein im Wert von 500€');
      setpicURL(edekaGiftCard);
      setBackgr1(euLadyBackgr1);
      setBackgr2(euLadyBackgr2);
      setCampaignName('DE EDEKA 500€');
    } 
    // Amazon 500€ offer
    else if (pageName.includes('amazon') && pageName.includes('500')) {
      setTitle('Amazon Geschenkkarte Gewinnspiel!');
      setHeadline('Ihr 500€ Amazon Gutschein');
      setpicURL(amazonGiftCard);
      setBackgr1(euLadyBackgr1);
      setBackgr2(euLadyBackgr2);
      setCampaignName('DE Amazon 500€');
    }
  }, [pageName]);

  return (
    <div>
      <Header />
      <div className="main-container">
        {loading ? (
          <div className="loader-div">
            <h2 id="loading-text">Überprüfung der Berechtigung...</h2>
            <br />
            <br />
            <Loader width="15.5em" height="12.23em" style={{ border: '1px solid black' }} />
          </div>
        ) : (
          <AngeboteBody
            title={title}
            headline={headline}
            picURL={picURL}
            backgroundPic1={backGr1}
            backgroundPic2={backGr2}
            textColorDesktop={textColorDesktop}
            textColorMobile={textColorMobile}
            campaignName={campaignName}
            translations={translations}
          />
        )}

        <MoreInfo translations={translations} />
      </div>
      <Footer translations={translations} />
      <GDPRCookieConsent locale="de" translations={translations} />
    </div>
  );
};

export default Angebote;
